export const FixedColumnKeys = ['actions'];
